import { useEffect, useState } from 'react';

import { portalLayout } from '@/theme/portalTokens';

const query = `(max-width: ${portalLayout.phoneMax}px)`;

/** O07: at and under portalLayout.phoneMax the shell is the phone layout (header + segments + cards + sticky footer). */
export function useIsPhone(): boolean {
  const [phone, setPhone] = useState(() =>
    typeof window !== 'undefined' && 'matchMedia' in window
      ? window.matchMedia(query).matches
      : false,
  );
  useEffect(() => {
    if (typeof window === 'undefined' || !('matchMedia' in window)) return;
    const mq = window.matchMedia(query);
    const on = () => setPhone(mq.matches);
    mq.addEventListener('change', on);
    return () => mq.removeEventListener('change', on);
  }, []);
  return phone;
}
